import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import CommonModal from 'src/common/config/CommonModal';
import { infoModalSxs } from 'src/content/billing/components/newChangePlan';
import { infoModalTexts } from 'src/common/config/TextMessage';
import { DownGradeOfferModal } from 'src/content/billing/components/DownGradeOfferModal';

import DeactivateHeader from './components/DeactivateHeader';
import FeedbackOptions from './components/FeedbackOptions';
import DeactivateActions from './components/DeactivateActions';
import { useDeactivateLogic } from './hooks/useDeactivateLogic';
import { DeactivateModalProps } from './types/deactivateTypes';

const DeactivateModal = ({ handCloseModal, isCancel = false }: DeactivateModalProps) => {
  const logic = useDeactivateLogic(handCloseModal, isCancel);

  return (
    <>
      <Backdrop
        sx={{ color: 'var(--color-white)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={logic.loading && !logic.openDowngradeOfferModal}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      
      <Box sx={infoModalSxs?.freeDowngradeMainBox}>
        <DeactivateHeader isCancel={isCancel} isLocalSeo={logic.isLocalSeo} handCloseModal={handCloseModal} />
        
        <FeedbackOptions 
          feedbackOptions={logic.feedbackOptions} selectedOption={logic.selectedOption} 
          otherReason={logic.otherReason} missingFeature={logic.missingFeature}
          isOtherFieldError={!!logic.isOtherFieldError} isMissingFieldError={!!logic.isMissingFieldError}
          isMinCharOtherError={!!logic.isMinCharOtherError} isMinCharMissingError={!!logic.isMinCharMissingError}
          isLocalSeo={logic.isLocalSeo} handleToggle={logic.handleToggle}
          setOtherReason={logic.setOtherReason} setMissingFeature={logic.setMissingFeature}
          setIsOtherFieldError={logic.setIsOtherFieldError} setIsMissingFieldError={logic.setIsMissingFieldError}
        />

        {logic.isNoOptionSelected && (
          <Box sx={infoModalSxs?.noSelectionErrorBox}>
            <img src={process.env.PUBLIC_URL + `/static/images/icons/red-info-dark.svg`} alt="Icon" style={infoModalSxs?.imgBoxSx} />
            <Typography sx={infoModalSxs?.noSelectionError}>{infoModalTexts?.noSelectionError}</Typography>
          </Box>
        )}

        <DeactivateActions activePlanName={logic.activePlanName} handCloseModal={handCloseModal} handleContinue={logic.handleContinue} />
      </Box>

      <CommonModal
        open={logic.openDowngradeOfferModal}
        handCloseModal={() => logic.setOpenDowngradeOfferModal(null)}
        title=""
        closebtn={false}
        blur={false}
        isAgencyModal={true}
        isInfoModal={true}
        isFreeDowngrade={true}
        isDownGradeOfferModal={true}
      >
        <DownGradeOfferModal
          handleCloseDownGradeOfferModal={() =>
            logic.setOpenDowngradeOfferModal(null)
          }
          selectedOption={logic.selectedOption}
          otherReason={logic.otherReason}
          missingFeature={logic.missingFeature}
          loading={logic.loading}
          handCloseModal={handCloseModal}
          handleDowngrade={logic.handleSubmits}
          isFromDeactivate={true}
          isSuccessfullySubmitted={logic.isSuccessfullySubmitted}
          error={logic.error}
          successMessage={logic.successMessage}
          selectedTimeLine={logic.selectedTimeLine}
        />
      </CommonModal>
    </>
  );
};

export default DeactivateModal;
